@if (!isHidden) {
  <rt-message
    class="{{ messageVariant }}"
    [class.transparent]="type === 'transparent'"
    [class.no-radius]="!rounded"
    [class.no-border]="noBorder"
    [class.padding-small]="messagePaddingSmall"
  >
    <div
      class="message-wrap"
      layout
      layout-full-width
      [class.information]="type === 'information'"
      [class.warning]="type === 'warning'"
      [class.error]="type === 'error'"
      [class.transparent]="type === 'transparent'"
      [class.success]="type === 'success'"
    >
      <div class="icon-wrap">
        @if (iconName) {
          <rt-icon
            [name]="iconName"
            [size]="iconSize"
            class="{{ type }}"
            [attr.margin-right-small]="!messagePaddingSmall || null"
            [attr.margin-right-small-x]="messagePaddingSmall || null"
          >
          </rt-icon>
        }
      </div>
      @if (imageTemplate) {
        <ng-template [ngTemplateOutlet]="imageTemplate"></ng-template>
      }
      <div class="text-wrap" layout layout-vertical layout-full-width>
        <div layout-horizontal>
          @if (heading) {
            <rt-heading>
              @if (headingBadge && isBadgeBeforeHeading) {
                <ng-template [ngTemplateOutlet]="hadingBadgeTpl"></ng-template>
              }
              {{ heading }}
              @if (headingBadge && !isBadgeBeforeHeading) {
                <ng-template [ngTemplateOutlet]="hadingBadgeTpl"></ng-template>
              }
              <ng-template #hadingBadgeTpl>
                <rt-badge
                  [color]="'primary-gradient'"
                  [text]="headingBadge"
                  [attr.margin-left-small-x]="!isBadgeBeforeHeading ? '' : null"
                  [attr.margin-right-small-x]="isBadgeBeforeHeading ? '' : null"
                >
                </rt-badge>
              </ng-template>
            </rt-heading>
          }
          @if (subheading) {
            <div layout class="subheading">
              <rt-divider variant="dot"></rt-divider>{{ subheading }}
            </div>
          }
        </div>
        <div layout layout-vertical>
          <span>
            <ng-content></ng-content>
          </span>
          @if (!!buttons?.length) {
            <div class="btns-wrap" margin-top-small-x>
              <rt-group variant="horizontal">
                @for (button of buttons; track trackBy($index, button)) {
                  <a rt-button target="_self" [variant]="button.variant" [href]="button.action">
                    {{ button.text }}
                  </a>
                }
              </rt-group>
            </div>
          }
        </div>
      </div>
      @if (isDismissible) {
        <rt-icon-button
          (click)="closeInfoBox($event)"
          class="close-btn"
          size="small"
          variant="plain"
          shape="square"
          iconName="close"
        >
        </rt-icon-button>
      }
    </div>
  </rt-message>
}
